import {AccessToken} from '../../Services/TokenService';
import {TokenService} from '../../Services/TokenService';
import {OfficeCompanionService} from '../../Services/OfficeCompanionService';

import {ArticleService} from '../../Services/ArticleService';
import {AuthorService} from '../../Services/AuthorService';
import {CategoryService} from '../../Services/CategoryService';
import {HomeService} from '../../Services/HomeService';
import {SurveyService} from '../../Services/SurveyService';
import {UserService} from '../../Services/UserService';
import {DashboardService} from '../../Services/DashboardService';
import {ExceptionService} from '../../Services/ExceptionService';
import {ImageService} from '../../Services/ImageService';
import {MetricService} from '../../Services/MetricService';
import {RoadmapService} from '../../Services/RoadmapService';
import {TicketService} from '../../Services/TicketService';

export const LOGIN = 'auth/LOGIN';
export const LOGOUT = 'auth/LOGOUT';
export const APPCRASH = 'auth/APPCRASH';
export const SET_DEBUG = 'auth/SET_DEBUG';
export const OPEN_DEVTOOLS = 'auth/OPEN_DEVTOOLS';

interface LoginAction {
  type: typeof LOGIN;
  payload: {
    clientCode: string;
    token: AccessToken;
  };
}

interface SetDebugAction {
  type: typeof SET_DEBUG;
  payload: boolean;
}

interface LogoutAction {
  type: typeof LOGOUT;
}

interface CrashAction {
  type: typeof APPCRASH;
}

export interface AuthState {
  clientCode: string;
  token: AccessToken;
  admin: boolean;
  appCrash: boolean;
  debug: boolean;

  tokenService: TokenService;
  officeCompanionService: OfficeCompanionService;

  authorised: boolean;
  articleService: ArticleService;
  authorService: AuthorService;
  categoryService: CategoryService;
  homeService: HomeService;
  surveyService: SurveyService;
  userService: UserService;
  dashboardService: DashboardService;
  exceptionService: ExceptionService;
  imageService: ImageService;
  metricService: MetricService;
  roadmapService: RoadmapService;
  ticketService: TicketService;
}

export type AuthActionTypes = LoginAction | LogoutAction | CrashAction | SetDebugAction;
